<div #userListContainingElement class="collapsible-user-list">
  <div class="user-list-caption">{{ label }}</div>
  <div class="user-list-wrapper">
    <div class="user-list-name" *ngFor="let userInfo of userList">
      <xs-user-info-popup [userInfo]="userInfo"> {{ userInfo.displayName }}; &nbsp; </xs-user-info-popup>
    </div>
  </div>

  <!-- expand user list -->
  <div class="user-list-toggle-button toggle-expand" *ngIf="isTruncated && !isExpanded">
    <button type="button" (click)="toggleShowFullUserList()">
      {{ 'user_List_More_Link_Caption' | xsI18n: numberOfHiddenUsers }}
      <div class="hd-icon hd-icon-doublearrow-down"></div>
    </button>
  </div>

  <!-- collapse user list -->
  <div class="user-list-toggle-button toggle-collapse" *ngIf="isExpanded">
    <button type="button" (click)="toggleShowFullUserList()">
      <div class="hd-icon hd-icon-doublearrow-up"></div>
    </button>
  </div>
</div>
